import {
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, MessageResult } from 'common/repositories/common.model';

import { RefundReleaseAgentInput } from './model';

export function useReleasingRefundReleaseAgent(
  options?: UseMutationOptions<
    MessageResult,
    ApiError,
    RefundReleaseAgentInput
  >,
): UseMutationResult<MessageResult, ApiError, RefundReleaseAgentInput> {
  return useMutation<MessageResult, ApiError, RefundReleaseAgentInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `release-purchases/${body.releasePurchaseId}/release`,
        method: 'POST',
      });
    },
    options,
  );
}
